<script>
    import TemplateSlide from '../../Models/templateSlideModel';
    import { handleError } from '../../Utilities/handlePromise';
    import Loader from '../Loader.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';

    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import SortableTable from '../SortableTable.svelte';

    let fields = [
        {
            name: "name",
            field: "name",
            label: "Slide Name",
            type: "text",
            required: true
        },
    ]

    function addSlide() {
        addFormModal({
            fields,
            title: "Add Slide"
        }).then((data) => {
            TemplateSlide.createItem(data).then(() => {
                notifier.success("Slide Created");
            }, handleError)
        }, handleError)
    }

    function deleteSlide(slide) {
        confirm(`Are you sure you want to delete ${slide.name}?`).then(() => {
            TemplateSlide.delete(slide._id).then(() => {
                notifier.success("Slide Deleted")
            }, handleError)
        }, handleError)
    }

    let slideList = TemplateSlide.getList();
</script>
<Loader loading={!$slideList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Template Slides</h1>
        <SortableTable sortFields={fields} tableData={$slideList}>
            <div slot="filterActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addSlide}>Add Slide</button>
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={slide}>
                <a class="button is-info" href="#/templateSlides/{slide._id}">Edit</a>
                <button class="button is-danger" on:click={() => deleteSlide(slide)}>Delete</button>
            </div>
            <div slot="footerActions">
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addSlide}>Add Slide</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>